const denominator: number = 10;

type Multiple = 0.25 | 0.5 | 1 | 2 | 3 | 4 | 5 | 8 | 10 | 20;
type Calc = (multiple: Multiple) => number;

export const calc: Calc = multiple => multiple * denominator;
